import { Button, Icon, Stack } from "@chakra-ui/react";
import { WSysHeaderButton, WSysPage, useWSysLayoutContext, useWSysPage, useWSysPath } from "@coimbra-its/websys-ux-core";
import { APPICONS } from "../Icons";
import { useWSysAuthSlice } from "../store/authSlice";
import { useKonyveloApi } from "../store/konyvelo.api";
import { useEffect } from "react";



export function Dashboard() {

	const api = useKonyveloApi();
	//const [data, hub] = api.dashboardGet.useData({});

	useEffect(() => {
		document.body.style.overscrollBehaviorY = 'initial';
		return () => {
			document.body.style.overscrollBehaviorY = 'contain';
		}
	}, [])

	const authSlice = useWSysAuthSlice();
	const user = useWSysAuthSlice(s => s.user);

	const path = useWSysPath();
	const page = useWSysPage({ title: 'WebSys Könyvelő v0.86', maxCols: 3, onClosed: false });
	const layoutCtx = useWSysLayoutContext();

	return <WSysPage page={page}
		tools={layoutCtx.isMobileFull && <WSysHeaderButton icon={<APPICONS.SignOut />}
			onClick={() => { authSlice.setShowSignOut(true) }} >Kilépés</WSysHeaderButton>}
	>
		<Stack px={4} py={8} justifyContent='flex-start' h='100%'>
			<Button onClick={() => path.open('beszla-online')} colorScheme="primary" ><Icon as={APPICONS.Szamlak} />&nbsp;Online számlák</Button>
			<Button onClick={() => path.open('beszla-jovahagyas')} colorScheme="primary" ><Icon as={APPICONS.Szamlak} />&nbsp;Számlák jóváhagyása</Button>
			<Button onClick={() => path.open('beszla')} colorScheme="primary" ><Icon as={APPICONS.Beszla} />&nbsp;Bejövő számlák</Button>
			<Button onClick={() => path.open('kiszla')} colorScheme="primary" ><Icon as={APPICONS.Kiszla} />&nbsp;Kimenő számlák</Button>
			<Button onClick={() => path.open('konnyuriport')} colorScheme="primary" ><Icon as={APPICONS.Chart} />&nbsp;Könnyű riportok</Button>
		</Stack>

	</WSysPage>
}
